/**
 * @namespace {BX.UI}
 */
export default class ButtonColor
{
	static DANGER = 'ui-btn-danger';
	static DANGER_DARK = 'ui-btn-danger-dark';
	static DANGER_LIGHT = 'ui-btn-danger-light';
	static SUCCESS = 'ui-btn-success';
	static SUCCESS_DARK = 'ui-btn-success-dark';
	static SUCCESS_LIGHT = 'ui-btn-success-light';
	static PRIMARY_DARK = 'ui-btn-primary-dark';
	static PRIMARY = 'ui-btn-primary';
	static SECONDARY = 'ui-btn-secondary';
	static LINK = 'ui-btn-link';
	static LIGHT = 'ui-btn-light';
	static LIGHT_BORDER = 'ui-btn-light-border';
	static AI = 'ui-btn-color-ai';
}